export const genreOptions = [
  'Afro House',
  'Bass / Club',
  'Breaks / Breakbeat / UK Bass',
  'Dance / Electro Pop',
  'Deep House',
  'Electro (Classic / Detroit / Modern)',
  'Electronic',
  'Electronica',
  'House',
  'Indie Dance',
  'Melodic House & Techno',
  'Minimal / Deep Tech',
  'Nu Disco / Disco',
  'Organic House / Downtempo',
  'Progressive House',
  'Tech House',
  'Techno',
  'Techno (Peak Time / Driving)',
  'Techno (Raw / Deep / Hypnotic)',
  'Trance',
];

export const setSortOptions = [
  { label: 'Artist: A-Z', value: 'artist', direction: 'asc' },
  { label: 'Artist: Z-A', value: 'artist', direction: 'desc' },
  { label: 'Title: A-Z', value: 'set_name', direction: 'asc' },
  { label: 'Title: Z-A', value: 'set_name', direction: 'desc' },
  { label: 'Curator: A-Z', value: 'sponsor', direction: 'asc' },
  { label: 'Curator: Z-A', value: 'sponsor', direction: 'desc' },
  { label: 'Genre: A-Z', value: 'genre', direction: 'asc' },
  { label: 'Genre: Z-A', value: 'genre', direction: 'desc' },
  {
    label: 'Release Date: Newest to Oldest',
    value: 'release_date',
    direction: 'desc',
  },
  {
    label: 'Release Date: Oldest to Newest',
    value: 'release_date',
    direction: 'asc',
  },
];

export const trackSortOptions = [
  { label: 'Artist: A-Z', value: 'artist', direction: 'asc' },
  { label: 'Artist: Z-A', value: 'artist', direction: 'desc' },
  { label: 'Title: A-Z', value: 'title', direction: 'asc' },
  { label: 'Title: Z-A', value: 'title', direction: 'desc' },
  { label: 'Label: A-Z', value: 'label_name', direction: 'asc' },
  { label: 'Label: Z-A', value: 'label_name', direction: 'desc' },
  { label: 'Genre: A-Z', value: 'genre', direction: 'asc' },
  { label: 'Genre: Z-A', value: 'genre', direction: 'desc' },
  {
    label: 'Purchase Date: Newest to Oldest',
    value: 'first_purchased_date',
    direction: 'desc',
  },
  {
    label: 'Purchase Date: Oldest to Newest',
    value: 'first_purchased_date',
    direction: 'asc',
  },
  {
    label: 'Release Date: Newest to Oldest',
    value: 'release_date',
    direction: 'desc',
  },
  {
    label: 'Release Date: Oldest to Newest',
    value: 'release_date',
    direction: 'asc',
  },
];

export const artistSortOptions = [
  { label: 'Artist Name: A-Z', value: 'name', direction: 'asc' },
  { label: 'Artist Name: Z-A', value: 'name', direction: 'desc' },
  { label: 'Set Count: Asc', value: 'set_count', direction: 'asc' },
  { label: 'Set Count: Desc', value: 'set_count', direction: 'desc' },
  { label: 'Latest Set: Newest', value: 'latest_set_date', direction: 'desc' },
  { label: 'Latest Set: Oldest', value: 'latest_set_date', direction: 'asc' },
  { label: 'Track Count: Asc', value: 'track_count', direction: 'asc' },
  { label: 'Track Count: Desc', value: 'track_count', direction: 'desc' },
  {
    label: 'Latest Track: Newest',
    value: 'latest_track_date',
    direction: 'desc',
  },
  {
    label: 'Latest Track: Oldest',
    value: 'latest_track_date',
    direction: 'asc',
  },
];

export const labelsSortOptions = [
  { label: 'Name: A-Z', value: 'name', direction: 'asc' },
  { label: 'Name: Z-A', value: 'name', direction: 'desc' },
  { label: 'Sets: Asc', value: 'set_count', direction: 'asc' },
  { label: 'Sets: Desc', value: 'set_count', direction: 'desc' },
  { label: 'Latest Set: Newest', value: 'latest_set_date', direction: 'desc' },
  { label: 'Latest Set: Oldest', value: 'latest_set_date', direction: 'asc' },
  { label: 'Track Count: Asc', value: 'track_count', direction: 'asc' },
  { label: 'Track Count: Desc', value: 'track_count', direction: 'desc' },
  {
    label: 'Latest Track: Newest',
    value: 'latest_track_date',
    direction: 'desc',
  },
  {
    label: 'Latest Track: Oldest',
    value: 'latest_track_date',
    direction: 'asc',
  },
  { label: 'Artist Count: Asc', value: 'artist_count', direction: 'asc' },
  { label: 'Artist Count: Desc', value: 'artist_count', direction: 'desc' },
];

export const idsSortOptions = [
  { label: 'Artist: A-Z', value: 'artist', direction: 'asc' },
  { label: 'Artist: Z-A', value: 'artist', direction: 'desc' },
  { label: 'Title: A-Z', value: 'title', direction: 'asc' },
  { label: 'Title: Z-A', value: 'title', direction: 'desc' },
  {
    label: 'First Liked: Newest to Oldest',
    value: 'first_liked_date',
    direction: 'desc',
  },
  {
    label: 'First Liked: Oldest to Newest',
    value: 'first_liked_date',
    direction: 'asc',
  },
  {
    label: 'Release Date: Newest to Oldest',
    value: 'release_date',
    direction: 'desc',
  },
  {
    label: 'Release Date: Oldest to Newest',
    value: 'release_date',
    direction: 'asc',
  },
  {
    label: 'First Seen: Newest to Oldest',
    value: 'created_dt',
    direction: 'desc',
  },
  {
    label: 'First Seen: Oldest to Newest',
    value: 'created_dt',
    direction: 'asc',
  },
];
